    package org.example.zone360.models

    import kotlinx.serialization.SerialName
    import kotlinx.serialization.Serializable
    import org.example.zone360.utils.SelectedLanguage

    @Serializable
    data class UserData(
        val id: String = "",
        val rev: String = "",
        val accessToken: String = "",
        val email: String = "",
        val firstName: String = "",
        val language: String = "en",
        val imageUrl: String = "",
        val lastName: String = "",
        val organization: String = "",
        val disabled: Boolean = false,
        val role: String = "",
        val status: String = "",
        val seasonID: String = "",
        val season: Season = Season(),
        val seasons: List<SeasonList> = emptyList(),
        val coachesAllowed : Int = 0,
        val payment: Payment = Payment(),
        val type: String = "",
        val uid: String = "",
        val clubName: String = "",
        @Serializable(with = TeamsObjectSerializer::class)
        val teams: List<TeamsObject> = emptyList(),
        val clubPayment: ClubPayment = ClubPayment(),
        val stripCustomerID: String? = null,
        val stripeSubscriptionID: String? = null,
    )
    @Serializable
    data class Season(
        val id: String = "",
        val name: String = "",
    )

    @Serializable
    data class SeasonList(
        val seasonID: String = "",
    )
    @Serializable
    data class ClubPayment(
        val amount: Long = 0L,
        val currency: String = "",
        @SerialName("expired_on")
        val expiredOn: String = "",
        @SerialName("paid_by")
        val paidBy: String = "",
        @SerialName("paid_by_email")
        val paidByEmail: String = "",
        @SerialName("paid_on")
        val paidOn: String = "",
        @SerialName("payment_id")
        val paymentId: String = "",
        val status: String = "",
    )
    @Serializable
    data class Payment(
        val subscription: Subscription = Subscription(),
        val checkout: Checkout = Checkout()
    )

    @Serializable
    data class Checkout(
        @SerialName("payment_id")
        val paymentId: String = "",
        val status: String = "",
        val currency: String = "",
        val amount: Long = 0L,
        @SerialName("paid_on")
        val paidOn: String = "",
        @SerialName("expired_on")
        val expiredOn: String = "",
        @SerialName("paid_by")
        val paidBy: String = "",
        @SerialName("paid_by_email")
        val paidByEmail: String = "",
        val source: String = "",
        val last_event: String = "",
        val updated_on: String = ""
    )

    @Serializable
    data class Subscription(
        val plan: String = "",
        val type: String = "",
        val status: String = "",
        val last_event: String = "",
        val updated_on: String = "",
        @SerialName("expired_on")
        val expiredOn: String = "",
        val last_invoice_id: String = "",
        val amount_paid: Long = 0L,
        val currency: String = "",
        @SerialName("paid_on")
        val paidOn: String = "",
        val cancel_at_period_end: Boolean = false
    )
    @Serializable
    data class CreatePlayerResponse(
        val data: String? = null,
        val error: String? = null,
        val message: String? = null,
        val userData: UserData? = null,
    )
